import Axios from "@/plugins/Axios";

/**
 * PEI — Plano Educacional Individualizado (#7286).
 *
 * O back devolve, junto do PEI, a identificação já preenchida e as listas de opções da
 * etapa do aluno (Infantil ou Fundamental), então o front não decide etapa nem duplica
 * as listas do formulário em papel.
 */
export class PeisService {
  async formulario(gestaoId, bimestre) {
    const response = await Axios().get(`peis/${gestaoId}/${bimestre}/formulario`);
    return response.data;
  }

  async salvar(gestaoId, pei) {
    const response = await Axios().post(`peis/${gestaoId}`, pei);
    return response.data;
  }

  async baixarPdf(gestaoId, bimestre) {
    return Axios()
      .get(`peis/${gestaoId}/${bimestre}/pdf`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        window.open(window.URL.createObjectURL(blob));
      });
  }
}

export default new PeisService();
